export default "__VITE_ASSET__BHNrAHaq__"